<template>
  <section class="dashboard-parcerias">
    <header class="dashboard-header">
      <div>
        <h3>Minhas Solicitações de Parceria</h3>
        <p>
          Acompanhe as solicitações de parceria enviadas e o status atual de
          cada uma
        </p>
      </div>
    </header>

    <div v-if="feedback.texto" class="feedback" :class="feedback.tipo">
      <span>{{ feedback.texto }}</span>
      <button type="button" aria-label="Fechar mensagem" @click="limparFeedback">
        ×
      </button>
    </div>

    <div class="cards-resumo" aria-label="Resumo das solicitações">
      <button type="button" class="card-resumo total" :class="{ selecionado: !filtros.status }"
        @click="selecionarStatus('')">
        <span class="rotulo">Total enviado</span>
        <strong>{{ resumo.total }}</strong>
        <small>Todas as solicitações</small>
      </button>

      <button type="button" class="card-resumo edicao" :class="{
        selecionado: filtros.status === STATUS_PARCERIA.EM_EDICAO,
      }" @click="selecionarStatus(STATUS_PARCERIA.EM_EDICAO)">
        <span class="rotulo">Em edição</span>
        <strong>{{ resumo.emEdicao }}</strong>
        <small>Aguardando envio pelo coordenador</small>
      </button>

      <button type="button" class="card-resumo pendente" :class="{
        selecionado:
          filtros.status === STATUS_PARCERIA.FORMULARIO_RECEBIDO,
      }" @click="selecionarStatus(STATUS_PARCERIA.FORMULARIO_RECEBIDO)">
        <span class="rotulo">Aguardando análise</span>
        <strong>{{ resumo.pendentes }}</strong>
        <small>Aguardando avaliação da PREX</small>
      </button>

      <button type="button" class="card-resumo analise" :class="{
        selecionado: filtros.status === STATUS_PARCERIA.EM_ANALISE,
      }" @click="selecionarStatus(STATUS_PARCERIA.EM_ANALISE)">
        <span class="rotulo">Em análise</span>
        <strong>{{ resumo.emAnalise }}</strong>
        <small>Em avaliação pela PREX</small>
      </button>

      <button type="button" class="card-resumo aguardando-articulacao" :class="{
        selecionado:
          filtros.status ===
          STATUS_PARCERIA.EM_ARTICULACAO_E_FORMALIZACAO,
      }" @click="
          selecionarStatus(
            STATUS_PARCERIA.EM_ARTICULACAO_E_FORMALIZACAO
          )
          ">
        <span class="rotulo">Em processo de articulação</span>
        <strong>{{ resumo.emArticulacao }}</strong>
        <small>Processo em andamento</small>
      </button>

      <button type="button" class="card-resumo aguardando-reitoria" :class="{
        selecionado:
          filtros.status ===
          STATUS_PARCERIA.AGUARDANDO_APROVACAO_REITORIA,
      }" @click="
          selecionarStatus(
            STATUS_PARCERIA.AGUARDANDO_APROVACAO_REITORIA
          )
          ">
        <span class="rotulo">Aguardando aprovação da reitoria</span>
        <strong>{{ resumo.aguardandoReitoria }}</strong>
        <small>Aguardando decisão da reitoria</small>
      </button>

      <button type="button" class="card-resumo aprovada" :class="{
        selecionado:
          filtros.status === STATUS_PARCERIA.PARCERIA_FORMALIZADA,
      }" @click="selecionarStatus(STATUS_PARCERIA.PARCERIA_FORMALIZADA)">
        <span class="rotulo">Formalizadas</span>
        <strong>{{ resumo.formalizadas }}</strong>
        <small>Parcerias formalizadas</small>
      </button>

      <button type="button" class="card-resumo reprovada" :class="{
        selecionado: filtros.status === STATUS_PARCERIA.REJEITADA,
      }" @click="selecionarStatus(STATUS_PARCERIA.REJEITADA)">
        <span class="rotulo">Indeferidas</span>
        <strong>{{ resumo.rejeitadas }}</strong>
        <small>Solicitações indeferidas</small>
      </button>

      <button type="button" class="card-resumo cancelada" :class="{
        selecionado: filtros.status === STATUS_PARCERIA.CANCELADA,
      }" @click="selecionarStatus(STATUS_PARCERIA.CANCELADA)">
        <span class="rotulo">Canceladas</span>
        <strong>{{ resumo.canceladas }}</strong>
        <small>Solicitações canceladas</small>
      </button>
    </div>

    <div class="painel-listagem">
      <div class="filtros">
        <div class="campo-busca">
          <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>

          <input v-model="filtros.busca" type="search" placeholder="Buscar por título, ação ou coordenador"
            aria-label="Buscar solicitações" @keyup.enter="aplicarFiltros" />
        </div>

        <select v-model="filtros.status" aria-label="Filtrar por status" @change="aplicarFiltros">
          <option value="">Todos os status</option>
          <option :value="STATUS_PARCERIA.EM_EDICAO">Em edição</option>
          <option :value="STATUS_PARCERIA.FORMULARIO_RECEBIDO">
            Aguardando análise
          </option>
          <option :value="STATUS_PARCERIA.EM_ANALISE">Em análise</option>
          <option :value="STATUS_PARCERIA.EM_ARTICULACAO_E_FORMALIZACAO">
            Em articulação
          </option>
          <option :value="STATUS_PARCERIA.AGUARDANDO_APROVACAO_REITORIA">
            Aguardando aprovação da reitoria
          </option>
          <option :value="STATUS_PARCERIA.PARCERIA_FORMALIZADA">
            Formalizadas
          </option>
          <option :value="STATUS_PARCERIA.REJEITADA">
            Indeferidas
          </option>
          <option :value="STATUS_PARCERIA.CANCELADA">
            Canceladas
          </option>
        </select>

        <button type="button" class="btn-filtrar" @click="aplicarFiltros">
          Buscar
        </button>
      </div>

      <Carregamento v-if="carregando" mensagemCarregamento="Carregando solicitações" />

      <div v-else-if="erro" class="estado-lista erro-lista">
        <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>

        <p>{{ erro }}</p>

        <button type="button" @click="carregarParcerias">
          Tentar novamente
        </button>
      </div>

      <div v-else-if="parceriasFiltradas.length === 0" class="estado-lista">
        <i class="fa-regular fa-folder-open" aria-hidden="true"></i>

        <p>
          Nenhuma solicitação encontrada para os filtros selecionados.
        </p>
      </div>

      <div v-else class="tabela-container">
        <table>
          <thead>
            <tr>
              <th>Ação vinculada</th>
              <th>Tipo</th>
              <th>Coordenador</th>
              <th>Solicitada em</th>
              <th>Status</th>
              <th>
                <span class="sr-only">Ações</span>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="parceria in parceriasFiltradas" :key="parceria.id">
              <td>
                <span class="acao-nome">
                  {{
                    parceria.nomeAcao ||
                    parceria.tituloAcao ||
                    "Não informado"
                  }}
                </span>
              </td>

              <td>
                <span class="tipo-parceria">
                  {{ traduzirTipoParceria(parceria.tipoParceria) }}
                </span>
              </td>

              <td>
                {{ parceria.nomeCoordenador || "Não informado" }}
              </td>

              <td>
                {{ formatarData(parceria.dataSolicitacao) }}
              </td>

              <td>
                <span class="status" :class="classeStatus(parceria.status)">
                  {{ textoStatus(parceria.status) }}
                </span>
              </td>

              <td class="celula-acoes">
                <div class="acoes-grupo">
                  <button type="button" class="btn-visualizar" :disabled="processandoId === parceria.id"
                    @click="verSolicitacao(parceria)">
                    Ver solicitação
                  </button>

                  <button v-if="podeEditarOuExcluir(parceria)" type="button" class="btn-editar-acao"
                    :disabled="processandoId === parceria.id" @click="abrirConfirmacaoEdicao(parceria)">
                    <i class="fa-solid fa-pen-to-square" aria-hidden="true"></i>
                    Editar
                  </button>

                  <button v-if="
                    parceria.status === STATUS_PARCERIA.EM_EDICAO
                  " type="button" class="btn-enviar-acao" :disabled="processandoId === parceria.id"
                    @click="enviarSolicitacao(parceria)">
                    <i class="fa-solid fa-paper-plane" aria-hidden="true"></i>
                    Enviar
                  </button>

                  <button v-if="podeEditarOuExcluir(parceria)" type="button" class="btn-excluir-acao"
                    :disabled="processandoId === parceria.id" @click="excluirSolicitacao(parceria)">
                    <i class="fa-solid fa-trash" aria-hidden="true"></i>
                    Excluir
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <footer v-if="!carregando && totalElementos > 0" class="paginacao">
        <span>
          Exibindo {{ inicioPagina }}–{{ fimPagina }}
          de {{ totalElementos }}
        </span>

        <div>
          <button type="button" :disabled="paginaAtual === 0" aria-label="Página anterior"
            @click="mudarPagina(paginaAtual - 1)">
            ‹
          </button>

          <span>
            Página {{ paginaAtual + 1 }} de {{ totalPaginas }}
          </span>

          <button type="button" :disabled="paginaAtual >= totalPaginas - 1" aria-label="Próxima página"
            @click="mudarPagina(paginaAtual + 1)">
            ›
          </button>
        </div>
      </footer>
    </div>

    <!-- Modal de confirmação de edição -->
    <div v-if="modalConfirmarEdicao.visivel" class="overlay" @click.self="fecharConfirmacaoEdicao">
      <div class="modal-confirmar-edicao" @click.stop>
        <div class="modal-header">
          <span class="modal-label">
            <i class="fa-solid fa-triangle-exclamation" aria-hidden="true" style="margin-right: 8px"></i>
            Atenção: Edição de solicitação
          </span>

          <button type="button" class="btn-fechar-modal" aria-label="Fechar" @click="fecharConfirmacaoEdicao">
            ×
          </button>
        </div>

        <div class="modal-body">
          <p>
            Ao editar esta solicitação, o status dela voltará para
            <strong>'Em edição'</strong> e ela precisará ser
            <strong>reenviada para análise da PREX</strong> após as
            alterações.
          </p>

          <div v-if="modalConfirmarEdicao.parceria" class="modal-destaque-edicao">
            <span class="destaque-rotulo">Ação vinculada:</span>

            <strong class="destaque-nome">
              {{
                modalConfirmarEdicao.parceria.nomeAcao ||
                modalConfirmarEdicao.parceria.tituloAcao ||
                "Solicitação de parceria"
              }}
            </strong>
          </div>

          <p class="pergunta-edicao">
            Deseja continuar para a edição?
          </p>
        </div>

        <div class="modal-footer-edicao">
          <button type="button" class="btn-cancelar-edicao" @click="fecharConfirmacaoEdicao">
            Cancelar
          </button>

          <button type="button" class="btn-prosseguir-edicao" @click="prosseguirParaEdicao">
            <i class="fa-solid fa-pen-to-square" aria-hidden="true"></i>
            Continuar para edição
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, reactive, computed, onMounted, watch } from "vue";
import { useRouter, useRoute } from "vue-router";

import parceriaService from "@/service/parceriaService";
import Carregamento from "@/components/common/Carregamento.vue";
import { useParceriasCoordenador } from "@/composables/useParceriasCoordenador";
import {
  STATUS_PARCERIA,
  STATUS_PARCERIA_LABEL,
} from "@/constants/parcerias";
import { formatarData } from "@/utils/FormatarEntradas";

const props = defineProps({
  acaoId: {
    type: String,
    default: "",
  },
});

const route = useRoute();
const router = useRouter();

const idAcaoAtual = computed(
  () => props.acaoId || route.params.id || ""
);

const {
  parceriasFiltradas,
  resumo,
  filtros,
  paginaAtual,
  totalPaginas,
  totalElementos,
  inicioPagina,
  fimPagina,
  carregando,
  erro,
  carregarParcerias,
  aplicarFiltros,
  selecionarStatus,
  mudarPagina,
} = useParceriasCoordenador({
  acaoId: idAcaoAtual.value,
  tamanhoPagina: 8,
});

const processandoId = ref(null);

const feedback = reactive({
  texto: "",
  tipo: "sucesso",
});

const modalConfirmarEdicao = reactive({
  visivel: false,
  parceria: null,
});

function limparFeedback() {
  feedback.texto = "";
}

function podeEditarOuExcluir(parceria) {
  return (
    parceria?.status === STATUS_PARCERIA.EM_EDICAO ||
    parceria?.status === STATUS_PARCERIA.FORMULARIO_RECEBIDO ||
    parceria?.status === STATUS_PARCERIA.REJEITADA ||
    parceria?.status === STATUS_PARCERIA.CANCELADA
  );
}

watch(idAcaoAtual, (novoId, idAnterior) => {
  if (novoId && novoId !== idAnterior) {
    carregarParcerias(novoId);
  }
});

watch(totalPaginas, (total) => {
  if (total > 0 && paginaAtual.value >= total) {
    mudarPagina(total - 1);
  }
});

function verSolicitacao(parceria) {
  if (!parceria?.id) return;

  const targetAcaoId =
    idAcaoAtual.value || parceria.acaoExtensaoId;

  router.push({
    name: "DetalhesParceria",
    params: {
      id: targetAcaoId,
      parceriaId: parceria.id,
    },
  });
}

function abrirConfirmacaoEdicao(parceria) {
  if (!parceria?.id) return;

  modalConfirmarEdicao.parceria = parceria;
  modalConfirmarEdicao.visivel = true;
}

function fecharConfirmacaoEdicao() {
  modalConfirmarEdicao.visivel = false;
  modalConfirmarEdicao.parceria = null;
}

function prosseguirParaEdicao() {
  const parceria = modalConfirmarEdicao.parceria;

  fecharConfirmacaoEdicao();

  if (!parceria?.id) return;

  const targetAcaoId =
    props.acaoId ||
    route.params.id ||
    parceria.acaoExtensaoId;

  const nomeRota =
    parceria.tipoParceria === "INTRA_MUROS" ||
      parceria.tipoParceria === "INTERNA"
      ? "formulario-parceria-interna"
      : "formulario-parceria-externa";

  router.push({
    name: nomeRota,
    params: {
      id: targetAcaoId,
      acaoId: targetAcaoId,
    },
    query: {
      parceriaId: parceria.id,
    },
  });
}

async function enviarSolicitacao(parceria) {
  if (!parceria?.id || processandoId.value !== null) return;

  processandoId.value = parceria.id;
  limparFeedback();

  try {
    await parceriaService.enviarParceria(parceria.id);

    feedback.tipo = "sucesso";
    feedback.texto =
      "Solicitação enviada para análise da PREX com sucesso!";

    await carregarParcerias(idAcaoAtual.value);
  } catch (error) {
    console.error(
      "Erro ao enviar solicitação de parceria:",
      error
    );

    feedback.tipo = "erro";
    feedback.texto =
      error?.response?.data?.message ||
      "Não foi possível enviar a solicitação de parceria.";
  } finally {
    processandoId.value = null;
  }
}

async function excluirSolicitacao(parceria) {
  if (!parceria?.id || processandoId.value !== null) return;

  const nome =
    parceria.nomeAcao ||
    parceria.tituloAcao ||
    "esta solicitação";

  const confirmou = window.confirm(
    `Deseja realmente excluir a solicitação de parceria "${nome}"? Esta ação não poderá ser desfeita.`
  );

  if (!confirmou) return;

  processandoId.value = parceria.id;
  limparFeedback();

  try {
    await parceriaService.excluirParceria(parceria.id);

    feedback.tipo = "sucesso";
    feedback.texto =
      "Solicitação de parceria excluída com sucesso.";

    await carregarParcerias(idAcaoAtual.value);
  } catch (error) {
    console.error(
      "Erro ao excluir solicitação de parceria:",
      error
    );

    feedback.tipo = "erro";
    feedback.texto =
      error?.response?.data?.message ||
      "Não foi possível excluir a solicitação de parceria.";
  } finally {
    processandoId.value = null;
  }
}

function textoStatus(status) {
  return (
    STATUS_PARCERIA_LABEL[status] ||
    status ||
    "Não informado"
  );
}

function classeStatus(status) {
  return status ? `status-${status.toLowerCase()}` : "";
}

function traduzirTipoParceria(tipo) {
  const tipos = {
    EXTERNA: "Externa",
    INTRA_MUROS: "Intra-muros",
    INTERNA: "Interna",
  };

  return tipos[tipo] || tipo || "Não informado";
}

onMounted(() => {
  carregarParcerias(idAcaoAtual.value);
});
</script>

<style scoped>
.dashboard-parcerias {
  width: 100%;
  color: var(--roxo-escuro);
}

.dashboard-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 22px;
}

.dashboard-header h3 {
  margin: 0 0 4px;
  color: var(--branco);
  font-size: 1.5rem;
  font-weight: 700;
}

.dashboard-header p {
  margin: 6px 0 0;
  color: var(--parcerias-subtitulo-cor, var(--cinza-medio));
  font-size: 0.9rem;
}

.feedback {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 0.85rem;
  font-weight: 600;
}

.feedback.sucesso {
  color: var(--verde-escuro, #166534);
  background: var(--verde-claro, #dcfce7);
}

.feedback.erro {
  color: var(--vermelho-escuro, #991b1b);
  background: var(--vermelho-claro, #fee2e2);
}

.feedback button {
  border: 0;
  color: inherit;
  background: transparent;
  font-size: 1.25rem;
  cursor: pointer;
}

/* Cards de resumo */
.cards-resumo {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 20px;
}

.card-resumo {
  position: relative;
  min-height: 130px;
  padding: 18px;
  overflow: hidden;
  border: 1px solid var(--roxo-superficie);
  border-radius: 14px;
  text-align: left;
  background: var(--branco);
  box-shadow: 0 5px 18px hsla(258, 55%, 15%, 0.06);
  cursor: pointer;
  transition:
    transform 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background-color 0.2s ease;
}

.card-resumo::after {
  position: absolute;
  right: -22px;
  bottom: -36px;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.15;
  content: "";
  pointer-events: none;
}

.card-resumo.total {
  color: var(--roxo-primario);
}

.card-resumo.edicao {
  color: #b45309;
}

.card-resumo.pendente {
  color: var(--azul-claro);
}

.card-resumo.analise {
  color: var(--azul-escuro);
}

.card-resumo.aguardando-articulacao {
  color: var(--verde);
}

.card-resumo.aguardando-reitoria {
  color: var(--laranja-escuro);
}

.card-resumo.aprovada {
  color: var(--roxo-medio);
}

.card-resumo.reprovada {
  color: var(--vermelho);
}

.card-resumo.cancelada {
  color: var(--cinza-escuro);
}

.card-resumo:hover,
.card-resumo.selecionado {
  transform: translateY(-2px);
  border: 2px solid white;
  box-shadow: 0 8px 22px hsla(258, 55%, 15%, 0.1);
}

.card-resumo.total:hover,
.card-resumo.total.selecionado {
  color: white;
  background: var(--roxo-escuro);
}

.card-resumo.edicao:hover,
.card-resumo.edicao.selecionado {
  color: white;
  background: #b45309;
}

.card-resumo.pendente:hover,
.card-resumo.pendente.selecionado {
  color: white;
  background: var(--azul-claro);
}

.card-resumo.analise:hover,
.card-resumo.analise.selecionado {
  color: white;
  background: var(--azul-escuro);
}

.card-resumo.aguardando-articulacao:hover,
.card-resumo.aguardando-articulacao.selecionado {
  color: white;
  background: var(--verde);
}

.card-resumo.aguardando-reitoria:hover,
.card-resumo.aguardando-reitoria.selecionado {
  color: white;
  background: var(--laranja-escuro);
}

.card-resumo.aprovada:hover,
.card-resumo.aprovada.selecionado {
  color: white;
  background: var(--roxo-medio);
}

.card-resumo.reprovada:hover,
.card-resumo.reprovada.selecionado {
  color: white;
  background: var(--vermelho);
}

.card-resumo.cancelada:hover,
.card-resumo.cancelada.selecionado {
  color: white;
  background: var(--cinza-escuro);
}

.card-resumo .rotulo,
.card-resumo small {
  display: block;
  color: currentColor;
}

.card-resumo .rotulo {
  font-size: 0.78rem;
  font-weight: 700;
}

.card-resumo strong {
  display: block;
  margin: 7px 0 1px;
  font-size: 2rem;
  line-height: 1;
}

.card-resumo small {
  font-size: 0.7rem;
  opacity: 0.75;
}

/* Painel da listagem */
.painel-listagem {
  overflow: hidden;
  border: 1px solid var(--roxo-superficie);
  border-radius: 15px;
  background: var(--branco);
  box-shadow: 0 6px 20px hsla(258, 55%, 15%, 0.06);
}

/* Filtros */
.filtros {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px;
  border-bottom: 1px solid var(--roxo-superficie);
  background: var(--roxo-superficie);
}

.campo-busca {
  position: relative;
  flex: 1;
  min-width: 0;
}

.campo-busca i {
  position: absolute;
  top: 50%;
  left: 14px;
  color: var(--cinza-medio);
  transform: translateY(-50%);
}

.campo-busca input,
.filtros select {
  box-sizing: border-box;
  width: 100%;
  min-height: 42px;
  border: 1px solid var(--roxo-superficie);
  border-radius: 9px;
  color: var(--cinza-escuro);
  background: var(--branco);
  font-size: 0.82rem;
  outline: none;
}

.campo-busca input {
  padding: 9px 14px 9px 40px;
}

.filtros select {
  width: 185px;
  padding: 8px 12px;
}

.campo-busca input:focus,
.filtros select:focus {
  border-color: var(--roxo-claro);
  box-shadow: 0 0 0 3px hsla(258, 70%, 58%, 0.12);
}

.btn-filtrar {
  min-height: 42px;
  padding: 9px 17px;
  border: 1px solid var(--roxo-medio);
  border-radius: 9px;
  color: var(--branco);
  background: var(--roxo-medio);
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s ease;
}

.btn-filtrar:hover {
  background: var(--roxo-primario);
}

/* Tabela */
.tabela-container {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.78rem;
}

th {
  padding: 13px 16px;
  color: var(--cinza-medio);
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: var(--roxo-superficie);
  font-size: 0.68rem;
  white-space: nowrap;
}

td {
  max-width: 220px;
  padding: 15px 16px;
  border-top: 1px solid var(--roxo-superficie);
  color: var(--cinza-escuro);
  vertical-align: middle;
}

tbody tr:hover {
  background: var(--roxo-superficie);
}

.acao-nome {
  color: var(--roxo-escuro);
  font-weight: 600;
}

.tipo-parceria {
  display: inline-flex;
  padding: 5px 9px;
  border-radius: 999px;
  color: var(--roxo-medio);
  background: var(--roxo-superficie);
  font-size: 0.68rem;
  font-weight: 700;
  white-space: nowrap;
}

/* Status */
.status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  padding: 6px 10px;
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1.35;
  text-align: center;
  white-space: normal;
  overflow-wrap: anywhere;
}

.status-em_edicao {
  color: #9a3412;
  background: #fff7ed;
  border-color: #fdba74;
}

.status-formulario_recebido {
  color: var(--branco);
  background: var(--azul-claro);
}

.status-em_analise {
  color: var(--branco);
  background: var(--azul-escuro);
}

.status-aguardando_ajustes {
  color: #9a3412;
  background: #fff7ed;
  border-color: #fdba74;
}

.status-em_articulacao_e_formalizacao {
  color: var(--branco);
  background: var(--verde);
}

.status-aguardando_aprovacao_reitoria {
  color: var(--branco);
  background: var(--laranja-escuro);
}

.status-parceria_formalizada {
  color: var(--branco);
  background: var(--roxo-medio);
}

.status-rejeitada {
  color: var(--branco);
  background: var(--vermelho-escuro);
}

.status-cancelada {
  color: var(--branco);
  background: var(--cinza-escuro);
}

/* Ações */
.celula-acoes {
  max-width: none;
  text-align: right;
}

.acoes-grupo {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 6px;
}

.btn-visualizar,
.btn-editar-acao,
.btn-enviar-acao,
.btn-excluir-acao {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 7px 11px;
  border: 0;
  border-radius: 8px;
  font-size: 0.72rem;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
  transition:
    background 0.2s ease,
    opacity 0.2s ease;
}

.btn-visualizar {
  color: var(--branco);
  background: var(--roxo-primario);
}

.btn-visualizar:hover:not(:disabled) {
  background: var(--roxo-medio);
}

.btn-editar-acao {
  color: var(--roxo-primario);
  background: var(--roxo-superficie);
  border: 1px solid var(--roxo-claro);
}

.btn-editar-acao:hover:not(:disabled) {
  color: var(--branco);
  background: var(--roxo-claro);
}

.btn-enviar-acao {
  color: var(--branco);
  background: var(--verde-escuro, #15803d);
}

.btn-enviar-acao:hover:not(:disabled) {
  background: var(--verde, #22c55e);
}

.btn-excluir-acao {
  color: var(--branco);
  background: var(--vermelho-escuro, #b91c1c);
}

.btn-excluir-acao:hover:not(:disabled) {
  background: var(--vermelho, #ef4444);
}

.btn-visualizar:disabled,
.btn-editar-acao:disabled,
.btn-enviar-acao:disabled,
.btn-excluir-acao:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* Estados da listagem */
.estado-lista {
  display: flex;
  min-height: 260px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 30px;
  color: var(--cinza-medio);
  text-align: center;
}

.estado-lista i {
  color: var(--roxo-claro);
  font-size: 2rem;
}

.estado-lista p {
  margin: 0;
  font-size: 0.86rem;
}

.estado-lista button {
  padding: 8px 12px;
  border: 0;
  border-radius: 8px;
  color: var(--branco);
  background: var(--roxo-medio);
  cursor: pointer;
}

.erro-lista i {
  color: var(--vermelho);
}

/* Paginação */
.paginacao {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  border-top: 1px solid var(--roxo-superficie);
  color: var(--cinza-medio);
  font-size: 0.73rem;
}

.paginacao>div {
  display: flex;
  align-items: center;
  gap: 9px;
}

.paginacao button {
  width: 32px;
  height: 32px;
  border: 1px solid var(--roxo-superficie);
  border-radius: 8px;
  color: var(--roxo-medio);
  background: var(--branco);
  font-size: 1.1rem;
  cursor: pointer;
}

.paginacao button:hover:not(:disabled) {
  background: var(--roxo-superficie);
}

.paginacao button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Responsividade */
@media (max-width: 1024px) {
  .cards-resumo {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .dashboard-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .filtros {
    flex-wrap: wrap;
  }

  .campo-busca {
    flex: 1 1 100%;
  }

  .filtros select {
    flex: 1 1 140px;
    width: auto;
  }

  .btn-filtrar {
    flex: 0 0 auto;
  }

  .paginacao {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}

@media (max-width: 480px) {
  .cards-resumo {
    grid-template-columns: 1fr;
  }

  .dashboard-header h3 {
    font-size: 1.2rem;
  }

  .dashboard-header p {
    font-size: 0.82rem;
  }
}

/* Modal de confirmação de edição */
.modal-confirmar-edicao {
  width: 100%;
  max-width: 480px;
  background: var(--branco);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  animation: fadeInModal 0.2s ease-out;
}

@keyframes fadeInModal {
  from {
    opacity: 0;
    transform: translateY(-8px) scale(0.98);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-confirmar-edicao .modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: var(--roxo-primario);
  color: var(--branco);
}

.modal-confirmar-edicao .modal-label {
  display: flex;
  align-items: center;
  font-size: 0.95rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--branco);
}

.modal-confirmar-edicao .btn-fechar-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 6px;
  color: var(--branco);
  background: transparent;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  transition: background 0.2s ease;
}

.modal-confirmar-edicao .btn-fechar-modal:hover {
  background: rgba(255, 255, 255, 0.2);
}

.modal-confirmar-edicao .modal-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px;
  background: var(--branco);
}

.modal-confirmar-edicao .modal-body p {
  margin: 0;
  color: #374151;
  font-size: 0.95rem;
  line-height: 1.55;
}

.modal-destaque-edicao {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 14px;
  border-left: 4px solid var(--roxo-primario);
  border-radius: 6px;
  background: #f7f4fc;
}

.destaque-rotulo {
  font-size: 0.8rem;
  text-transform: uppercase;
  color: #6b7280;
  font-weight: 600;
  letter-spacing: 0.04em;
}

.destaque-nome {
  font-size: 0.95rem;
  color: var(--roxo-primario);
  word-break: break-word;
}

.pergunta-edicao {
  font-weight: 600;
  color: #111827 !important;
}

.modal-footer-edicao {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 14px 20px;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
}

.btn-cancelar-edicao {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
  padding: 0 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: var(--branco);
  color: #374151;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-cancelar-edicao:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.btn-prosseguir-edicao {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 38px;
  padding: 0 18px;
  border: none;
  border-radius: 6px;
  background: var(--roxo-primario);
  color: var(--branco);
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
}

.btn-prosseguir-edicao:hover {
  background: var(--roxo-medio);
}
</style>
